import Button from '../../../../../../../../components/button';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {
	customFieldDetails as setCustomFieldDetails, putCustomField
} from '../../../../../../../../../actions/customFieldsActions';
import Icon from '../../../../../../../../components/icon';
import './index.css';

function CustomFieldTypes ({item}) {

	const [dropDownCustomField, setDropDownCustomField] = useState("");
	const [showSaveButton, setShowSaveButton] = useState(false);

	const customFieldDetails = useSelector((state) => state.customFieldsReducer.customFieldDetails);
	const language = useSelector(state => state.languageReducer.language);

	const dispatch = useDispatch();

	const {t} = useTranslation();

	const handleCheck = (e) => {
		if(e.target.value === "text"){
			setDropDownCustomField("");
			if(customFieldDetails){
				dispatch(setCustomFieldDetails(null));
			}
			if(item.valueType === "DROPDOWN"){
				setShowSaveButton(true);
			} else {
				setShowSaveButton(false);
			}
		} else {
			if(showSaveButton){
				setShowSaveButton(false);
			}
			setDropDownCustomField(e.target.value);
		}
	};

	const handleCustomFieldParam = () => {
		dispatch(setCustomFieldDetails({id: item.id, type: item.valueType, name: item.label, dropDownOptions: item.dropdownOptions }));
	};

	const handleClick = () => {
		dispatch(putCustomField(item.id, item.label, "TEXT"))
	}

	useEffect(() => {
		if(item.valueType === "TEXT"){
			setShowSaveButton(false);
		} else {
			setDropDownCustomField(item.label);
		}
	}, [item]);

	return (
		<div className="custom-field-types">
			{t('customFieldsTypeOfCustomField')}{language === "fr" ? ' ' : ''}:
			<div className="custom-control custom-radio ml-4">
				<input
					className="custom-control-input"
					type="radio"
					id={`text-cf-${item.id}`}
					name={`type-custom-field-${item.id}`}
					defaultChecked={item.valueType === 'TEXT'}
					value="text"
					onChange={ handleCheck }
				/>
				<label className="custom-control-label"
				       htmlFor={`text-cf-${item.id}`}>
					{t('customFieldsManagerTextRadio')}
				</label>
			</div>
			<div className="custom-control custom-radio ml-4">
				<input
					className="custom-control-input"
					type="radio"
					id={`dropdown-cf-${item.id}`}
					name={`type-custom-field-${item.id}`}
					defaultChecked={item.valueType === 'DROPDOWN'}
					value={item.id}
					onChange={ handleCheck }
				/>
				<label className="custom-control-label"
				       htmlFor={`dropdown-cf-${item.id}`}>
					{t('customFieldsManagerDropDownRadio')}
				</label>
			</div>
			{
				dropDownCustomField
				&&
					<Button
						className="btn-link custom-field-param"
						onClick={ handleCustomFieldParam }
					>
						<Icon name="cog" title={t('customFieldsManagerParametersBtn')}/>
					</Button>
			}
			{
				showSaveButton && <Button onClick={ handleClick } className="p-0 btn-link ml-auto font-weight-normal">Save Change</Button>
			}
		</div>
	)
}

export default CustomFieldTypes;
